module.exports = __webpack_public_path__ + "img/skip-back.dc70c15c.svg";